export const DEFAULT_DRAWER_WIDTH = 425

/**
 * Duration of the drawer's slide transition, in milliseconds.
 *
 * Shared by Drawer.style.js (the CSS `transition`) and Drawer.jsx (the
 * CSSTransition `timeout`). These MUST agree: the timeout is the fallback that
 * releases onEntered/onExited when no `transitionend` arrives — because the
 * transform did not change, motion is reduced, or the node is hidden. If the
 * timeout is shorter than the CSS duration it wins the race instead, firing
 * onExited before the animation has played and letting consumers unmount the
 * drawer mid-slide (Issue 1: the Fast Feature Mapping modal did not animate out).
 */
export const DRAWER_TRANSITION_MS = 300
export const FEATURE_DRAWER_WIDTH = 1025
export const HARNESS_DRAWER_WIDTH = 1042
export const SWGA_BUILDER_INVENTORY_WIDTH = 1025
export const TAB_WIDTH = 18
